"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionListViewStyle = exports.SessionListTitle = exports.SessionListInfoContainer = exports.SessionListContainer = exports.SessionInfoTile = exports.RotatedIcon = exports.ExportSessionsButton = exports.ExpandButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const SessionListTile_style_1 = require("./SessionsListTile/SessionListTile.style");
const SessionListViewStyle = styled_components_1.default.div `
  position: fixed;
  top: 10.5rem;
  right: 1.25rem;
  bottom: 1.25rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
  padding-right: 0.8rem;
  width: 25rem;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
exports.SessionListViewStyle = SessionListViewStyle;
const SessionListTitle = styled_components_1.default.span `
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.2rem;
  color: ${colors_1.gray400};
  align-items: center;

  &:nth-of-type(2) {
    margin-left: 0.3rem;
  }
`;
exports.SessionListTitle = SessionListTitle;
const SessionListInfoContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
exports.SessionListInfoContainer = SessionListInfoContainer;
const SessionListContainer = styled_components_1.default.div `
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  width: calc(100% + 1rem);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;

  &::-webkit-scrollbar-button:end:decrement {
    padding-bottom: 1rem;
  }
`;
exports.SessionListContainer = SessionListContainer;
const ExportSessionsButton = styled_components_1.default.button `
  background-color: transparent;
  color: ${colors_1.acBlueDark};
  border: none;
  font-size: 1.2rem;
  text-transform: uppercase;
  cursor: ${({ $hasSessions }) => ($hasSessions ? "pointer" : "default")};
`;
exports.ExportSessionsButton = ExportSessionsButton;
const SessionInfoTile = (0, styled_components_1.default)(SessionListTile_style_1.SessionListTile) `
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  cursor: default;
`;
exports.SessionInfoTile = SessionInfoTile;
const ExpandButton = styled_components_1.default.button `
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;
exports.ExpandButton = ExpandButton;
const RotatedIcon = styled_components_1.default.img `
  transform: ${({ $rotated }) => ($rotated ? "rotate(180deg)" : "none")};
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.3rem;
`;
exports.RotatedIcon = RotatedIcon;
